
<template>
  <v-container>
    <v-btn
      icon
      to="/tasklist/traininglist"
    >
      <v-icon>{{ mdiArrowLeft }}</v-icon>
    </v-btn>

    <v-layout>
      <v-flex
        md10
        offset-md1
      >
        <s-training-task :courseid="courseId" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import STrainingTask from './components/STrainingTask'
import { mdiArrowLeft } from '@mdi/js'

export default {
  components: {
    STrainingTask
  },
  props: {
    courseId: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      mdiArrowLeft: mdiArrowLeft
    }
  }
}

</script>
